var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaderStatus)?_c('div',{staticClass:"loader text-center"},[_c('font-awesome-icon',{staticClass:"fa-4x",attrs:{"icon":['far', 'spinner'
          ],"spin":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }